<template>
  <div class="delivery-place__city">
    <i class="icn-location"></i>
    <span class="open-modal-shipment-cities" data-bs-toggle="modal" data-bs-target="#modal-shipment-cities">{{ selectedCity }}</span>

    <div
        class="modal fade"
        id="modal-shipment-cities"
        tabindex="-1"
        aria-modal="true"
        role="dialog"
        aria-labelledby="modalLocationLabel"
        aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <i class="modal-close icn-close" role="button" data-bs-dismiss="modal"></i>
          <h3 class="modal-title" id="modalLocationLabel">
            Выберите город отгрузки
          </h3>
          <div class="modal-body">
            <div class="row">
              <div class="col-lg-7 col-md-12">
                <form>
                  <div class="input-group">
                    <input v-model="filter"
                           type="text"
                           class="form-control"
                           placeholder="Быстрый поиск"
                           @change="filterChanged()"
                    >
                  </div>
                </form>
              </div>
            </div>
            <div class="city-list pt-4 pb-4">
              <ul class="city-list__parent">
                <li v-for="cityGroup in citiesGroups">
                  <span>{{ cityGroup && cityGroup.letter }}</span>
                  <ul class="city-list__inner">
                    <li
                        class="city-item"
                        :class="{'city-item_selected':city.CITY_NAME==selectedCity}"
                        :key="cities.ID"
                        v-for="city in cityGroup.cities"
                        @click="citySelected(city)"
                        :data-city="city.CITY_NAME"
                    >
                      {{ city.CITY_NAME }}
                    </li>
                  </ul>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: "ShipmentCities",
  props: {
    selectedCity: {
      type: String,
      required: true,
    },
  },
  data() {
    console.log(this);
    return {
      /** Города отгрузки для выбора */
      cities: this.$root.JS_DATA.LOCATIONS,
      filter: ''
    };
  },

  methods: {
    citySelected(city) {
      this.$emit('shipment-city-selected', city);
      $('#modal-shipment-cities').modal('hide');
      let currentCity = document.querySelector('[data-bs-target="#modal-shipment-cities"]').innerText;
      gaPush.sendToGA(
          'GAevent',
          'delivery',
          'changeGeoClick',
          currentCity + ';' + city.CITY_NAME,
          {'dimension7': window.dimension7, 'dimension11': currentCity}
      );
    },
    filterChanged(){
      if(document.querySelector('[data-bs-target="#modal-shipment-cities"]')) {
        gaPush.sendToGA(
            'GAevent',
            'delivery',
            'fastSearchFilial',
            document.querySelector('[data-bs-target="#modal-shipment-cities"]').innerText,
            {
              'dimension7': window.dimension7,
              'dimension11': document.querySelector('[data-bs-target="#modal-shipment-cities"]').innerText
            }
        );
      }
    }
  },

  computed: {
    citiesGroups() {
      const filtered = this.cities
          .filter(city => this.filter.length == 0 ? true
              : !city.IS_LETTER && city.CITY_NAME.toLowerCase().indexOf(this.filter.toLowerCase()) > -1);
      let result = {};
      filtered.map((cur)=>{
        if(!cur.IS_LETTER) {
          const letter = cur.CITY_NAME.charAt(0);
          if (typeof result[letter] == 'undefined') {
            result[letter] = {letter: letter, cities: [cur]};
          } else {
            result[letter].cities.push(cur);
          }
        }
      })
      return result;
    }
  }
};
</script>

<style scoped>
.city-list__inner li,.delivery-place__city .open-modal-shipment-cities{
  cursor: pointer;
}
.city-list__parent li:hover span, .delivery-place__city .city-item:hover{
  color: #dc7015;
}
.city-item_selected{
  font-weight: 550;
}
.delivery-place__city .modal-content{
  min-height: 695px;
}
</style>